import { orange } from "@material-ui/core/colors";
import { isIFrame } from "utils";

export const TOOLBAR_OFFSET = 80;

export const IFARAME_OFFSET = 30;

export const SIDE_PANEL_OFFSET = 300;

export const INFO_PANEL_OFFSET = 48; // spacing(6);

export const truncate = (width: string) => {
    return `
        max-width: ${width};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
  `;
};

/**
 * calculates container ratio
 * @param width
 * @param ratio default value is set to 16:9
 */
export const calculateRatio = (width: number, ratio = 56.25) => {
    return `
        height: ${(width * ratio) / 100}px;
    `;
};

export const maxHeightWithOffset = () => {
    return `
        height: calc(100vh - ${isIFrame ? IFARAME_OFFSET : TOOLBAR_OFFSET}px);
    `;
};

export const transition = (delay = 1) => {
    return `
        transition: all ${delay}s ease;
    `;
};

export const selectionBorder = (shadow: string, selected?: boolean, enablePointer = true) => {
    return `
        position: relative;
        ${enablePointer ? "cursor: pointer" : ""};
        box-shadow: ${selected ? `0 0 0 3px ${orange["700"]}` : shadow};
    `;
};
